import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        icons: {
            iconfont: 'mdi'
        },
        themes: {
            dark: {
                primary: '#4f83cc',
                //secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
                upt: '#01579b'
            },
            light: {
                primary: '#4f83cc',
                //secondary: '#FF5E3C',
                secondary: '#01579b',
                accent: '#9E9E9E',
                upt: '#01579b'
            }
        }
    }
});
